<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          title="قائمة المستخدمين"
          text="تفاصيل مستخدمي النظام و مجاميعهم"
        >

          <v-container>
            <v-row>
              <v-col cols="12" md="4" xs="12" sm="12">
                <v-btn large color="green" dark class="mb-2" @click="addNewUser">إضافة مستخدم جديد</v-btn>
              </v-col>
              <v-col cols="12" md="8" xs="12" sm="12">
                <v-text-field
                        filled
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="بحث ..."
                        single-line
                        v-on:key.enter="getPatients"
                        hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-container>


          <v-data-table
                  :loading="isloading"
                  :loading-text="loadingtext"
                  :headers="headers"
                  :items="items"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>

            <template v-slot:item.province="{ item }">
              <v-chip>{{ getProvince(item.province) }}</v-chip>
            </template>


            <template v-slot:item.action="{ item }">
              <v-btn
                      primary
                      dark
                      center
                      @click="editItem(item)">
              <v-icon
                      medium

              >
                mdi-pencil
              </v-icon>
              </v-btn>
              <v-btn
                      warning
                      dark
                      @click="deleteItem(item)">
              <v-icon
                      medium
              >
                mdi-delete
              </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
//import Axios from 'axios'
import {__HTTP,FormHeader,__HAS_PERM} from '@/utils/utils'
export default {
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    getProvince(item){
      var y = this.$store.state.iraqprovs.filter(xc => xc.value == item)
      return(y[0].text)
    },
    getUsers() {
      __HTTP("?do=getusers",{keyword: this.search ? this.search : ""},FormHeader,(res) => {
        console.log(res);
        this.items = res;

         this.isloading = false
      })
    },
    editItem (item) {
      this.$router.push({path: '/edit-user', query: {id: item.id}});
    },
    addNewUser() {
      this.$router.push({path: '/new-user', query: {}})
    },
    deleteItem (item) {
      const index = this.items.indexOf(item)
      let c = confirm('Are you sure you want to delete this item?');
      if (c) {
        __HAS_PERM(31,this.$store.state.loggedUser.id,() => {
          __HTTP("?do=delete",{type: "user",id: item.id},FormHeader,() => {
            this.items.splice(index, 1)
          })
        });
      }
    },
    editItemxx() {
      this.$router.push({path: '/edit-user', query: {pid: this.toBeEdit.id}})
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.items.push(this.editedItem)
      }
      this.close()
    },
  },
  created() {this.getUsers()},
  data: () => ({
    search: '',
    isloading: true,
    loadingtext: "يرجى الانتظار جاري تحميل البيانات",
    dialog: false,
    toBeEdit: null,
    cards: [],
    headers: [
      {
        sortable: true,
        text: 'الإسم',
        value: 'fullname',
        align: 'right'
      },
      {
        sortable: true,
        text: 'إسم المستخدم',
        value: 'username',
        align: 'right'
      },
      {
        sortable: true,
        text: 'المحافظة',
        value: 'province',
        align: 'right'
      },
      {
        sortable: true,
        text: 'دائرة الصحة',
        value: 'healthdep',
        align: 'right'
      },
      {
        sortable: true,
        text: 'القطاع',
        value: 'healthsector',
        align: 'right'
      },
      {
        sortable: true,
        text: 'المركز الصحي',
        value: 'healthcenter',
        align: 'right'
      },
      {
        sortable: true,
        text: 'المجموعة',
        value: 'groupid',
        align: 'right'
      },
      {
        sortable: true,
        text: 'الصنف',
        value: 'profile',
        align: 'right'
      },
      { text: 'الادوات', value: 'action', sortable: false },
    ],
    items: [

    ]
  })
}
</script>
